import Script from 'next/script';
import { useEffect, useRef, useState } from 'react';

import type { Component, OnChartDraw } from './types';
import { onChartReady } from './utils';

export const LineChart: Component = ({
  chartClassName,
  onChartDraw,
}) => {
  const [
    isGoogleChartScriptLoaded,
    setIsGoogleChartScriptLoaded,
  ] = useState(false);
  const chartContentElRef = useRef<HTMLDivElement | null>(null);
  const onChartDrawRef = useRef<OnChartDraw | null | undefined>(null);

  onChartDrawRef.current = onChartDraw;

  useEffect(() => {
    if (!isGoogleChartScriptLoaded) {
      return undefined;
    }

    const { current: chartContent } = chartContentElRef;

    if (!chartContent) {
      return undefined;
    }

    const onChartRefresh = () => {
      onChartReady(() => {
        onChartDrawRef.current?.({
          element: chartContent,
        });
      });
    };

    const onWindowResize = () => {
      onChartRefresh();
    };

    onChartRefresh();

    window.addEventListener('resize', onWindowResize);

    return () => {
      window.removeEventListener('resize', onWindowResize);
    };
  }, [
    isGoogleChartScriptLoaded,
    onChartDraw,
  ]);

  return (
    <>
      <Script
        src="https://www.gstatic.com/charts/loader.js"
        onLoad={() => {
          setIsGoogleChartScriptLoaded(true);
        }}
        onReady={() => {
          setIsGoogleChartScriptLoaded(true);
        }} />
      <div
        ref={chartContentElRef}
        className={chartClassName} />
    </>
  );
};
